var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyBothManualAutomated({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 121,
    viewBox: "0 0 139 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 90V38",
    stroke: "#19D89F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 113h70.488V98H107M28 67.5v-30",
    stroke: "#F8D856",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 60h54.315v61H0V60z",
    fill: "#5959EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 66h42v48H6V66z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 79c0-1.657 1.445-3 3.228-3h26.544C42.555 76 44 77.343 44 79s-1.445 3-3.228 3H14.228C12.445 82 11 80.657 11 79zM11 90c0-1.657 1.445-3 3.228-3h26.544C42.555 87 44 88.343 44 90s-1.445 3-3.228 3H14.228C12.445 93 11 91.657 11 90zM11 101c0-1.657 1.445-3 3.228-3h26.544C42.555 98 44 99.343 44 101s-1.445 3-3.228 3H14.228c-1.783 0-3.228-1.343-3.228-3z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36.5h65",
    stroke: "#19D89F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139 33c0 18.225-14.775 33-33 33S73 51.225 73 33 87.775 0 106 0s33 14.775 33 33z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.895 7h9.579v4.795a21.817 21.817 0 0 1 7.686 3.705l3.026-3.026 6.773 6.773-3.571 3.571a21.705 21.705 0 0 1 1.817 4.708H133v9.58h-4.49a21.718 21.718 0 0 1-2.018 5.876l3.467 3.467-6.773 6.774-2.854-2.854a21.812 21.812 0 0 1-7.858 3.836V59h-9.579v-4.49a21.783 21.783 0 0 1-8.616-3.688l-2.4 2.4-6.774-6.773 2.774-2.774a21.749 21.749 0 0 1-2.39-6.57H81v-9.579h4.795a21.76 21.76 0 0 1 2.194-5.395l-2.884-2.884 6.774-6.773 2.578 2.578a21.777 21.777 0 0 1 8.438-3.563V7zM107 42.579c5.29 0 9.579-4.289 9.579-9.579A9.58 9.58 0 1 0 107 42.579z",
    fill: "#BF3DC2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 38,
    r: 10,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 97,
    r: 10,
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyBothManualAutomated);
export default __webpack_public_path__ + "static/media/survey-both-manual-automated.087bab48bd50603054fb0e6316fe24ec.svg";
export { ForwardRef as ReactComponent };